import { Component, OnInit } from '@angular/core';
import { DeleteUser, LoginResponse } from '../models/login';
import { Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { HttpClient } from '@angular/common/http';
import { ApiService } from '../Services/api-service';
import { SharedService } from '../Services/shared-service.service';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
@Component({
  selector: 'app-userdelete',
  templateUrl: './userdelete.component.html',
  styleUrls: ['./userdelete.component.css']
})

export class UserdeleteComponent implements OnInit {

  show: boolean = false;
  formval: DeleteUser = new DeleteUser();
  display: boolean = false;
  modeldisplay: boolean = false;
  ForgotPwdFrom: FormGroup;
  termsConditionModal: boolean = false;
  constructor(private fb: FormBuilder, private sharedService: SharedService, private service: ApiService, private router: Router, private toastr: ToastrService) { }

  ngOnInit() {
    console.log(localStorage)
    this.ForgotPwdFrom = this.fb.group({
      Email: ['', Validators.required]
    })
  }

  openTermsConditionModel() {

    this.termsConditionModal = true;

  }
  get u() {
    return this.ForgotPwdFrom.controls
  }
  onSubmit() {
    this.show = true;
    console.log("Form Data:", this.formval);
    if (!this.formval.Mobile || !this.formval.Password) {
      this.toastr.warning('All fields are required', 'Warning!', { timeOut: 3000 });
      return;
    }

    const requestData = {
      Mobile: this.formval.Mobile,
      Password: this.formval.Password
    };
    console.log("requestData:", requestData);
    debugger
    this.service.PostApiLogin(requestData, "User/deleteUser").subscribe(
      (response: any) => {
        debugger
        console.log("Response:", response);
        if (response.ResponseCode === 200) {
          debugger;
          this.show = false;
          this.toastr.success("User deleted successfully", "Success!", {
            timeOut: 3000
          });
          // Perform any additional actions if needed
        } else if (response.ResponseCode === 404) {
          // Handle "User not found" case
          this.show = false;
          this.toastr.error(response.ResponseMessage, "Warning!", {
            timeOut: 3000
          });
        } else {
          // Handle other error cases
          this.show = false;
          this.toastr.error(response.ResponseMessage, "Error!", {
            timeOut: 3000
          });
        }
      }
    );
  }
  ShowforgotPassword() {
    // this.termsConditionModal = true;
    this.display = true;
    this.modeldisplay = false;
    // this.toastrService.info('', 'Please contact to admin...',
    //   {
    //     positionClass: 'toast-top-right'
    //   }
    // );
  }


}